import StatusPill from "./StatusPill";
import VehicleCard from "./VehicleCard";
import { BoardColumn } from "../../data/productionLineMock";

type Props = {
  column: BoardColumn;
  onAddNote?: (columnId: string) => void;
  onRaiseAlert?: (columnId: string) => void;
  onOpenForm?: (columnId: string) => void;
  onOpenVideo?: (columnId: string) => void;
};

export default function Column({ column, onAddNote, onRaiseAlert, onOpenForm, onOpenVideo }: Props) {
  const hideActions = column.stage === "checkin";

  return (
    <div className="w-64 shrink-0 flex flex-col rounded-lg bg-gray-50 dark:bg-gray-950 ring-1 ring-gray-200 dark:ring-gray-800">
      <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100 leading-none">{column.title}</h3>
        <StatusPill status={column.status} />
      </div>
      <div className="p-2 space-y-2 overflow-y-auto">
        {column.vehicles.map((v) => (
          <VehicleCard
            key={v.id}
            vehicle={v}
            showChecklist={column.stage !== "checkin"}
          />
        ))}
        {column.vehicles.length === 0 && (
          <div className="text-sm text-gray-500 dark:text-gray-400 px-1 py-4 text-center">
            No vehicles
          </div>
        )}
      </div>
      {!hideActions && (
        <div className="px-2 pb-2 pt-1 mt-auto grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={() => onAddNote?.(column.id)}
            className="inline-flex items-center justify-center rounded-md bg-red-600 hover:bg-red-700 text-white text-xs font-medium px-2 py-1.5"
          >
            Add Note
          </button>
          <button
            type="button"
            onClick={() => onRaiseAlert?.(column.id)}
            className="inline-flex items-center justify-center rounded-md bg-yellow-400 hover:bg-yellow-300 text-gray-900 text-xs font-medium px-2 py-1.5"
          >
            Raise Alert
          </button>
          <button
            type="button"
            onClick={() => onOpenForm?.(column.id)}
            className="inline-flex items-center justify-center rounded-md bg-red-600 hover:bg-red-700 text-white text-xs font-medium px-2 py-1.5"
          >
            Form
          </button>
          <button
            type="button"
            onClick={() => onOpenVideo?.(column.id)}
            className="inline-flex items-center justify-center rounded-md bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium px-2 py-1.5"
          >
            Video
          </button>
        </div>
      )}
    </div>
  );
}


